import ReportStatus from "../commons/model/report/ReportStatus";
import { StatusInfo } from "./Report";
import FlowType from "../commons/model/FlowType";

export default class ReportFragment {
  uid: string;
  subjectName: string;
  statusInfo: StatusInfo;
  technicalErrorMsg?: string;
  read: boolean;
  reportType: FlowType;
}

export const isAccessible = (report: ReportFragment) => {
  switch (report.statusInfo.status) {
    case ReportStatus.AVAILABLE:
    case ReportStatus.SHARED_WITH_PATIENT:
    case ReportStatus.VIEWED_BY_PATIENT:
    case ReportStatus.REJECTED:
    case ReportStatus.INCOMPLETE:
      return true;
    case ReportStatus.ANALYSING:
    case ReportStatus.TECHNICAL_ERROR:
    case ReportStatus.UPLOADING:
      return false;
  }
};

export const isClickable = (report: ReportFragment) => {
  return (
    isAccessible(report) ||
    [ReportStatus.UPLOADING, ReportStatus.ANALYSING].includes(report.statusInfo.status)
  );
};
